import { Anchor, InputBase } from '@sparemin/blockhead';
import React from 'react';
import { KeyTextType } from 'types';
import { block } from './utils';

export type TextOverlayDynamicOptionProps = {
  type: KeyTextType;
  isChecked?: boolean;
  isDisabled?: boolean;
  onClick?: (type: KeyTextType) => void;
};

const TextOverlayDynamicOption: React.FC<TextOverlayDynamicOptionProps> = ({
  type,
  isChecked,
  isDisabled,
  onClick,
}) => {
  const id = `${type}-option`;

  return (
    <label
      htmlFor={id}
      className={block('option', {
        checked: isChecked,
      })}
    >
      <InputBase
        inputComponent="input"
        inputComponentProps={{
          id,
          type: 'radio',
          checked: isChecked,
          disabled: isDisabled,
          onClick: () => onClick?.(type),
        }}
      />
      <Anchor />

      {`${type === 'episodeTitle' ? 'Episode' : 'Podcast'} title`}
    </label>
  );
};

export default TextOverlayDynamicOption;
